import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import ConfirmDialog from "./ConfirmDialog";

export default function PageWrapper(props: any) {
  const navigate = useNavigate();

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  return (
    <Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h6" fontWeight={600}>
          {props.title}
        </Typography>

        <Box display="flex" gap={1}>
          {/* Default Add Button */}
          {props.buttonTitle && (
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              sx={{
                backgroundColor: "#fcb500",
                color: "#000",
                fontWeight: 600,
              }}
              onClick={() => handleNavigate(props.navigateTo)}
            >
              {props.buttonTitle}
            </Button>
          )}

          {/* Extra Button(s) if passed */}
          {props.extraAction}
        </Box>
      </Box>

      {props.children}

      {props.open !== undefined && props.onClose && props.onConfirm && (
        <ConfirmDialog
          open={props.open}
          description={`Are you sure you want to delete this ${props.actionName}? This action cannot be undone.`}
          onClose={props.onClose}
          onConfirm={props.onConfirm}
        />
      )}
    </Box>
  );
}
